<div class="container my-5">
  <h3 class="text-center mb-4">
    {{ 'solicitud-documentos.documentos' | translate }}
  </h3>
  <form
    [formGroup]="solicitudForm"
    (ngSubmit)="onSubmit()"
    class="wrapper__form__content row g-3">
    <div class="row mb-3">
      <div class="col-md-12">
        <div class="form-group">
          <label for="remitente" class="form-label text3-tipografia-govco"
            >{{ 'solicitud-documentos.remitente' | translate }} </label
          ><span class="text-danger"> *</span>
          <input
            type="text"
            class="form-control"
            id="remitente"
            formControlName="remitente"
            [ngClass]="{
              'is-invalid':
                solicitudForm.get('remitente')?.invalid &&
                solicitudForm.get('remitente')?.touched,
            }" />
          <div
            *ngIf="
              solicitudForm.get('remitente')?.invalid &&
              solicitudForm.get('remitente')?.touched
            ">
            <div
              *ngIf="solicitudForm.get('remitente')?.errors?.['required']"
              class="invalid-feedback">
              {{ 'solicitud-documentos.remitente-obligatorio' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <div class="form-group">
          <label
            for="correoRespuesta"
            class="form-label text3-tipografia-govco"
            >{{ 'solicitud-documentos.correo' | translate }}</label
          ><span class="text-danger"> *</span>
          <input
            type="text"
            class="form-control"
            id="correoRespuesta"
            formControlName="correoRespuesta"
            [ngClass]="{
              'is-invalid':
                solicitudForm.get('correoRespuesta')?.invalid &&
                solicitudForm.get('correoRespuesta')?.touched,
            }" />
          <div
            *ngIf="
              solicitudForm.get('correoRespuesta')?.invalid &&
              solicitudForm.get('correoRespuesta')?.touched
            ">
            <div
              *ngIf="solicitudForm.get('correoRespuesta')?.errors?.['required']"
              class="invalid-feedback">
              {{ 'solicitud-documentos.correo-obligatorio' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <div class="form-group">
          <label
            for="otrosDestinatarios"
            class="form-label text3-tipografia-govco"
            >{{ 'solicitud-documentos.destinatarios' | translate }}</label
          >
          <input
            type="text"
            class="form-control"
            id="otrosDestinatarios"
            formControlName="otrosDestinatarios"
            placeholder="correo1@email.com, correo2@email.com"
            [ngClass]="{
              'is-invalid':
                solicitudForm.get('otrosDestinatarios')?.invalid &&
                solicitudForm.get('otrosDestinatarios')?.touched,
            }" />
          <div
            *ngIf="
              solicitudForm.get('otrosDestinatarios')?.invalid &&
              solicitudForm.get('otrosDestinatarios')?.touched
            ">
            <div
              *ngIf="
                solicitudForm.get('otrosDestinatarios')?.errors?.[
                  'invalidEmails'
                ]
              "
              class="invalid-feedback">
              {{ 'solicitud-documentos.destinatarios-validacion' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <div class="form-group">
          <label for="asunto" class="form-label text3-tipografia-govco">{{
            'solicitud-documentos.asunto' | translate
          }}</label
          ><span class="text-danger"> *</span>
          <select
            formControlName="asunto"
            class="form-select"
            type="text"
            id="asunto"
            [ngClass]="{
              'is-invalid':
                solicitudForm.get('asunto')?.invalid &&
                solicitudForm.get('asunto')?.touched,
            }">
            <option disabled selected value="">
              {{ 'solicitud-documentos.seleccione' | translate }}
            </option>
            <option *ngFor="let asunto of asuntosList" [value]="asunto.Id">
              {{ asunto.Valor }}
            </option>
          </select>
          <div
            *ngIf="
              solicitudForm.get('asunto')?.invalid &&
              solicitudForm.get('asunto')?.touched
            ">
            <div
              *ngIf="solicitudForm.get('asunto')?.errors?.['required']"
              class="invalid-feedback">
              {{ 'solicitud-documentos.asunto-obligatorio' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <div class="form-group">
          <label
            for="numeroProceso"
            class="form-label text3-tipografia-govco"
            >{{ 'solicitud-documentos.proceso' | translate }}</label
          ><span class="text-danger"> *</span>
          <input
            type="text"
            class="form-control"
            id="numeroProceso"
            formControlName="numeroProceso"
            [ngClass]="{
              'is-invalid':
                solicitudForm.get('numeroProceso')?.invalid &&
                solicitudForm.get('numeroProceso')?.touched,
            }" />
          <div
            *ngIf="
              solicitudForm.get('numeroProceso')?.invalid &&
              solicitudForm.get('numeroProceso')?.touched
            ">
            <div
              *ngIf="solicitudForm.get('numeroProceso')?.errors?.['required']"
              class="invalid-feedback">
              {{ 'solicitud-documentos.proceso-obligatorio' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-md-12">
        <div class="form-group">
          <label for="descripcion" class="form-label text3-tipografia-govco">{{
            'solicitud-documentos.descripcion' | translate
          }}</label
          ><span class="text-danger"> *</span>
          <textarea
            type="text"
            class="form-control"
            id="descripcion"
            formControlName="descripcion"
            maxlength="600"
            rows="5"
            [ngClass]="{
              'is-invalid':
                solicitudForm.get('descripcion')?.invalid &&
                solicitudForm.get('descripcion')?.touched,
            }"></textarea>
          <div
            *ngIf="
              solicitudForm.get('descripcion')?.invalid &&
              solicitudForm.get('descripcion')?.touched
            ">
            <div
              *ngIf="solicitudForm.get('descripcion')?.errors?.['required']"
              class="invalid-feedback">
              {{ 'solicitud-documentos.descripcion-obligatorio' | translate }}
            </div>
            <div
              *ngIf="solicitudForm.get('descripcion')?.errors?.['maxlength']"
              class="invalid-feedback">
              {{ 'solicitud-documentos.descripcion-validacion' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center">
      <button
        type="submit"
        class="btn-govco outline-btn-govco hvr-shrink"
        [disabled]="solicitudForm.invalid"
        aria-label="Enviar solicitud de documentos">
        {{ 'solicitud-documentos.enviar' | translate }}
      </button>
    </div>
  </form>
</div>
